import { Module } from 'vuex';

import { LeaguesMeta, RootState } from 'frontend/types';

const leaguesMeta: Module<LeaguesMeta, RootState> = {
  namespaced: true,
  state: {
    enable_leagues: false,
  },
  getters: {
    enableLeagues: (state: LeaguesMeta): LeaguesMeta['enable_leagues'] => state.enable_leagues,
  },
  mutations: {
    setValue(state: LeaguesMeta, value: LeaguesMeta): void {
      Object.assign(state, value);
    },
  },
};

export default leaguesMeta;
